/**
 * Actions for Units module
 */
import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function getCourseTasks(payload) {
  return { type: actionTypes.GET_TASKS, payload };
}
export function getCourseTasksSuccess(payload) {
  let index = 0;
  const byId = keyBy(payload, (course) => {
    return index++;
  });
  return { type: actionTypes.GET_TASKS_SUCCESS, payload: { byId } };
}
